import { useDispatch } from 'react-redux';

import {
  injectedRtkApi,
  S3SignedRetrieveApiArg,
  S3SignedUploadUrl,
} from 'services/api/ailyssaApi';
import type { AppDispatch } from 'store/store';
import { AxiosFileClient } from 'libs/axios';
import { AxiosRequestConfig } from 'axios';
import { usePlatformConfigContext } from 'contexts/PlatformConfigContext';

const useGetS3Url = () => {
  const dispatch: AppDispatch = useDispatch();

  return (filename: string, context: S3SignedRetrieveApiArg['context']) => {
    const action = injectedRtkApi.endpoints.s3SignedRetrieve.initiate({
      filename,
      context,
    });

    return new Promise<S3SignedUploadUrl>((resolve, reject) => {
      dispatch(action)
        .unwrap()
        .then((resp) => {
          resolve(resp);
        })
        .catch(reject);
    });
  };
};

const useHandleUploadFile = () => {
  const { environment } = usePlatformConfigContext();
  const headers = { 'Content-Type': 'application/octet-stream' };

  return (file: File, url: string) =>
    new Promise((resolve, reject) => {
      const config: AxiosRequestConfig = {};

      if (environment === 'on-premise') {
        config.withCredentials = true;
      }

      AxiosFileClient.put(url, file, {
        headers,
        ...config,
      })
        .then((resp) => resolve(resp))
        .catch(reject);
    });
};

export { useGetS3Url, useHandleUploadFile };
